module.exports = __webpack_public_path__ + "static/media/shape_3.f742e85c.png";